import { Trans } from '@lingui/macro';
import { ArrowRightAlt } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { ReactNode, useMemo, type FC } from 'react';
import { GREEN } from '../constants';
import { PanelPaper } from './common';
import { MovementSummaryAttribute as Renderer } from './dataComponents/MovementSummaryAttribute';

interface Props {
  movementId: number | null;
}

export const PanelSummary: FC<Props> = ({ movementId }) => {
  const fields = useMemo(() => {
    return [
      {
        id: 0,
        label: <Trans>Operación compuerta</Trans>,
        value: (
          <>
            <Renderer movementId={movementId} attribute="startPosition" />{' '}
            <ArrowRightAlt fontSize="small" sx={{ mt: '2px' }} />{' '}
            <span style={{ color: GREEN }}>
              <Renderer movementId={movementId} attribute="requestedPosition" />
            </span>
          </>
        ),
      },
      {
        id: 2,
        label: <Trans>Solicitado por</Trans>,
        value: <Renderer movementId={movementId} attribute="requestedBy" />,
      },
      {
        id: 3,
        label: <Trans>Fecha solicitud</Trans>,
        value: <Renderer movementId={movementId} attribute="requestedTimestamp" />,
      },
      {
        id: 4,
        label: <Trans>Código de la operación</Trans>,
        value: movementId,
      },
      {
        id: 1,
        label: <Trans>Operacion iniciada hace</Trans>,
        value: <Renderer movementId={movementId} attribute="startTimestamp" />,
      },
    ];
  }, [movementId]);

  return (
    <PanelPaper
      sx={{
        flexGrow: 1,
        py: 2,
        gridArea: 'summary',
        display: 'grid',
        alignContent: 'center',
        gap: 2,
      }}
    >
      <Typography textAlign="center" variant="h6" mb={2} lineHeight={1.2}>
        <Trans>
          Resumen
          <br />
          <span style={{ whiteSpace: 'nowrap' }}>de la operación</span>
        </Trans>
      </Typography>

      <Box display="flex" gap={2} flexDirection="column">
        {fields.map(({ id, ...props }) => (
          <Field key={id} {...props} />
        ))}
      </Box>
    </PanelPaper>
  );
};

const Field: FC<{ label: ReactNode; value: ReactNode }> = ({ label, value }) => {
  return (
    <Box textAlign="center">
      <Typography
        sx={{
          border: 1,
          fontWeight: 'medium',
          mb: 1,
          borderColor: '#ffffff60',
          borderRadius: 1,
        }}
      >
        {label}
      </Typography>
      <Typography fontWeight="bold" display="inline-flex" alignItems="center" gap="2px">
        {value}
      </Typography>
    </Box>
  );
};
